module.exports = __webpack_public_path__ + "img/p9-p3-text.9033f76b.png";